import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {LEVELROLE,RESOURCES,LEVEL_ROLE_QUESTIONS,ASSESSMENT_HISTORY,ASSESSMENT_HISTORY_MASTER} from "./type";


export const getLevelsByRole = (roleId) => async (dispatch) => {
    dispatch({ type: LEVELROLE, payload: null });
    dispatch({ type: LEVEL_ROLE_QUESTIONS, payload: null });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.assesment.levelsByRoleId}?role_id=${roleId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: LEVELROLE, payload: data.response.data });
      return data.response.data;
    }
  };

export const getAssessmentHistory = (roleId,levelId) => async (dispatch) => {
    dispatch({ type: ASSESSMENT_HISTORY, payload: null });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.assesment.getAssessmentHistory}?role_id=${roleId}&level_id=${levelId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: ASSESSMENT_HISTORY, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getMasterAssessmentHistory = (page=1) => async (dispatch) => {
    dispatch({ type: ASSESSMENT_HISTORY_MASTER, payload: null });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.assesment.getMasterAssessmentHistory}?page=${page}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: ASSESSMENT_HISTORY_MASTER, payload: data.response.data });
      return data.response.data;
    }
  };

  export const getLevelQuestionssByRoleAndLevel = (roleId,levelId) => async (dispatch) => {
    
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.assesment.questionsByRoleAndLevel}?role_id=${roleId}&level_id=${levelId}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: LEVEL_ROLE_QUESTIONS, payload: data.response.data });
      return data.response.data;
    }
  };

  export const submitAssessmentTest = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      `${Config.assesment.submitAssessmentTest}`
    );
    if (res) {
      const { data } = res;
      if(data.response.data === true) {
         return true;
      } else {
        return false;
      }
    }
  };

  export const getResources = (level,roleId,searchKey = null) => async (dispatch) => {
    dispatch({ type: RESOURCES, payload: null });
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.assesment.getResources}?role_id=${roleId}&level_id=${level}&search_key=${searchKey}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: RESOURCES, payload: data.response.data });
      return data.response.data;
    }
  };
